import React, { useState } from "react";
import LegalDocument from "./LegalDocument";

import { SeCheckbox, SeButton } from "@se/web-ui-react";
import MainLayout from "./MainLayout";
import "./index.scss"
import { useNavigate } from "react-router-dom";
const TermsAndConditions = props => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate  = useNavigate();

  const onCheckboxClick = event => {
    setIsChecked(event.target.selected);
  };

  const onButtonClick = () => {
    navigate("/dashboard");
  };
  return (
    <div className="legal-agreement">
      <MainLayout>
        <LegalDocument />

        <div className="agreement-form">
          <SeCheckbox
            onClick={onCheckboxClick}
            label="I agree to the above Terms and Conditions"
          />
          <SeButton
            disabled={!isChecked}
            onClick={onButtonClick}
            color="primary"
          >
            Continue
          </SeButton>
        </div>
      </MainLayout>
    </div>
  );
};

export default TermsAndConditions;
